<div class="w-full flex h-screen">
  <div class="lg:col-6 xl:col-8 col-12 h-full flex align-items-center justify-content-center">
    <div class="max-w-28rem w-full">
      <div class="flex flex-column gap-5 p-4">
        <div class="w-full flex align-items-center justify-content-center lg:hidden">
          <img src="../../../assets/images/logo.svg" alt="" class="w-full max-w-8rem" />
        </div>
        <form #userForm="ngForm" (ngSubmit)="onSubmit(userForm)" class="flex flex-column gap-4">
          <h1 class="text-4xl">Staff Sign In</h1>

          <ul class="flex flex-column gap-5">
            <li class="flex flex-column gap-2">
              <label for="email">Email Address</label>
              <input
                type="email"
                id="email"
                pInputText
                [(ngModel)]="email"
                #emailInput="ngModel"
                name="email"
                required
                pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
                styleClass="epno"
              />
              @if(emailInput.dirty && emailInput.invalid){
              <small class="text-left text-sm text-red-600">
                @if(emailInput.errors?.['required']){ Email is Required ! }
                @if(emailInput.errors?.['pattern']){ Enter a valid Email! }
              </small>
              }
            </li>
            <li class="flex flex-column gap-2">
              <label for="password">Password</label>

              <input
                type="password"
                id="password"
                autocomplete="on"
                pInputText
                [(ngModel)]="password"
                #passwordInput="ngModel"
                name="password"
                required
                styleClass="epno"
              />
              @if(passwordInput.dirty && passwordInput.invalid){
              <small class="text-left text-sm text-red-600">
                @if(passwordInput.errors?.['required']){ Password is Required !
                }
              </small>
              }
            </li>
            <li class="flex flex-column gap-2">
              <p-button
                label="Sign In"
                type="submit"
                [loading]="loading"
                [disabled]="userForm.invalid"
                styleClass="login_btn"
              />
            </li>
          </ul>
        </form>
      </div>
    </div>
  </div>
  <div class="h-full lg:col-6 lg:flex xl:col-4 xl:flex align-items-center justify-content-center loginWrapper_right hidden">
    <div class="logo">
      <img src="../../../assets/images/logo.svg" alt="" />
    </div>
  </div>
</div>
